export default __webpack_public_path__ + "static/media/N49.c760c18a.png";